/* rcb-lp.js — Recalibite landing page behavior (gallery, purchase selector, AJAX cart, sticky bar) */
(function () {
  'use strict';

  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ── Purchase config (rendered by Liquid) ── */
  var cfgEl = qs('[data-rcb-config]');
  var CFG = null;
  try { CFG = cfgEl ? JSON.parse(cfgEl.textContent) : null; } catch (e) { CFG = null; }
  var mode = CFG && CFG.defaultMode ? CFG.defaultMode : 'once';

  function applyMode(m) {
    if (!CFG || !CFG[m]) return;
    mode = m;
    var c = CFG[m];
    qsa('[data-rcb-purchase-opt]').forEach(function (opt) {
      var sel = opt.getAttribute('data-rcb-purchase-opt') === m;
      opt.setAttribute('data-selected', sel ? 'true' : 'false');
      opt.setAttribute('aria-pressed', sel ? 'true' : 'false');
    });
    qsa('[data-rcb-selling-plan-input]').forEach(function (i) { i.value = c.planId || ''; i.disabled = !c.planId; });
    qsa('[data-rcb-atc-label]').forEach(function (el) { el.textContent = c.atc; });
    qsa('[data-rcb-summary-type]').forEach(function (el) { el.textContent = c.type; });
    qsa('[data-rcb-summary-price]').forEach(function (el) { el.textContent = c.price; });
    qsa('[data-rcb-summary-reg]').forEach(function (el) { el.textContent = c.reg; });
    qsa('[data-rcb-summary-save]').forEach(function (el) { el.textContent = c.save; });
  }
  qsa('[data-rcb-purchase-opt]').forEach(function (opt) {
    opt.addEventListener('click', function () { applyMode(opt.getAttribute('data-rcb-purchase-opt')); });
  });
  if (CFG) applyMode(mode);

  /* ── Gallery ──
     The viewer is a flush scroll-snap track: native swipe/trackpad scrolling drives it,
     the next slide's edge peeks in, and arrows/dots/thumbs scroll it programmatically. */
  (function () {
    var track = qs('[data-rcb-track]');
    if (!track) return;
    var slides = qsa('[data-rcb-slide]', track);
    if (slides.length < 2) return;

    var thumbs = qsa('[data-rcb-thumb]');
    var dots = qsa('[data-rcb-dot]');
    var prevBtn = qs('[data-rcb-prev]');
    var nextBtn = qs('[data-rcb-next]');
    var idx = 0;

    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }

    function syncTo(i) {
      if (i === idx) return;
      idx = i;
      thumbs.forEach(function (t, ti) { t.setAttribute('data-active', ti === i ? 'true' : 'false'); });
      dots.forEach(function (d, di) { d.setAttribute('data-active', di === i ? 'true' : 'false'); });
      if (prevBtn) prevBtn.disabled = (i === 0);
      if (nextBtn) nextBtn.disabled = (i === slides.length - 1);
      var active = thumbs[i];
      if (active && active.scrollIntoView) {
        active.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    }

    /* Derive the current slide from scroll position — keeps native swipe in sync */
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var mid = track.scrollLeft + track.clientWidth / 2;
        var best = 0, bestDist = Infinity;
        slides.forEach(function (s, si) {
          var c = s.offsetLeft - track.offsetLeft + s.offsetWidth / 2;
          var d = Math.abs(c - mid);
          if (d < bestDist) { bestDist = d; best = si; }
        });
        syncTo(best);
        ticking = false;
      });
    }, { passive: true });

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(idx - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(idx + 1); });
    thumbs.forEach(function (t, ti) { t.addEventListener('click', function () { goTo(ti); }); });
    dots.forEach(function (d, di) { d.addEventListener('click', function () { goTo(di); }); });

    if (prevBtn) prevBtn.disabled = true;
    if (nextBtn) nextBtn.disabled = (slides.length < 2);
  })();

  /* ── Mobile menu ── */
  var burger = qs('[data-rcb-burger]');
  var headerEl = qs('[data-rcb-header]');
  if (burger && headerEl) {
    burger.addEventListener('click', function () {
      var open = headerEl.classList.toggle('rcb-menu-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    qsa('.rcb-mobilenav a', headerEl).forEach(function (a) {
      a.addEventListener('click', function () { headerEl.classList.remove('rcb-menu-open'); });
    });
  }

  /* ── Sticky mobile ATC ── */
  var sticky = qs('[data-rcb-sticky]');
  if (sticky) {
    var onScroll = function () {
      var show = window.scrollY > 700 && window.innerWidth < 900;
      sticky.classList.toggle('is-visible', show);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  /* ── Reviews: chips + load more (visual) ── */
  qsa('[data-rcb-chip]').forEach(function (chip) {
    chip.addEventListener('click', function () {
      qsa('[data-rcb-chip]').forEach(function (c) { c.setAttribute('data-active', 'false'); });
      chip.setAttribute('data-active', 'true');
    });
  });
  var loadMore = qs('[data-rcb-loadmore]');
  if (loadMore) {
    loadMore.addEventListener('click', function () {
      qsa('[data-rcb-review-hidden]').forEach(function (r) { r.style.display = ''; r.removeAttribute('data-rcb-review-hidden'); });
      loadMore.parentNode.style.display = 'none';
    });
  }

  /* ── Cart ── */
  var drawer = qs('[data-rcb-drawer]');
  var overlay = qs('[data-rcb-overlay]');

  function openDrawer() { refreshCart(); if (drawer) { drawer.classList.add('is-open'); } if (overlay) { overlay.classList.add('is-open'); } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); } if (overlay) { overlay.classList.remove('is-open'); } }
  qsa('[data-rcb-open-cart]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); }); });
  qsa('[data-rcb-close-cart]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  if (overlay) overlay.addEventListener('click', closeDrawer);

  function renderCart(cart) {
    qsa('[data-rcb-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    var body = qs('[data-rcb-drawer-lines]');
    var empty = qs('[data-rcb-drawer-empty]');
    if (empty) empty.style.display = cart.items.length ? 'none' : 'block';
    if (body) {
      body.innerHTML = '';
      cart.items.forEach(function (item, idx) {
        var line = document.createElement('div');
        line.className = 'rcb-line';
        var img = document.createElement('img');
        img.className = 'rcb-line__img';
        img.alt = '';
        if (item.image) { img.src = item.image.replace(/(\.[a-zA-Z]+)(\?|$)/, '_120x$1$2'); }
        var info = document.createElement('div');
        info.className = 'rcb-line__info';
        var name = document.createElement('div');
        name.className = 'rcb-line__name';
        name.textContent = item.product_title;
        var desc = document.createElement('div');
        desc.className = 'rcb-line__desc';
        var bits = [];
        if (item.variant_title && item.variant_title !== 'Default Title') bits.push(item.variant_title);
        if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) { bits.push(item.selling_plan_allocation.selling_plan.name); } else { bits.push('One-Time Purchase'); }
        desc.textContent = bits.join(' · ');
        var qrow = document.createElement('div');
        qrow.className = 'rcb-line__qtyrow';
        var dec = document.createElement('button');
        dec.className = 'rcb-line__qbtn'; dec.setAttribute('aria-label', 'Decrease quantity'); dec.textContent = '−';
        var qty = document.createElement('span');
        qty.className = 'rcb-line__qty'; qty.textContent = item.quantity;
        var inc = document.createElement('button');
        inc.className = 'rcb-line__qbtn'; inc.setAttribute('aria-label', 'Increase quantity'); inc.textContent = '+';
        var rem = document.createElement('button');
        rem.className = 'rcb-line__remove'; rem.textContent = 'Remove';
        dec.addEventListener('click', function () { changeLine(idx + 1, item.quantity - 1); });
        inc.addEventListener('click', function () { changeLine(idx + 1, item.quantity + 1); });
        rem.addEventListener('click', function () { changeLine(idx + 1, 0); });
        qrow.appendChild(dec); qrow.appendChild(qty); qrow.appendChild(inc); qrow.appendChild(rem);
        info.appendChild(name); info.appendChild(desc); info.appendChild(qrow);
        var total = document.createElement('div');
        total.className = 'rcb-line__total';
        total.textContent = money(item.final_line_price);
        line.appendChild(img); line.appendChild(info); line.appendChild(total);
        body.appendChild(line);
      });
    }
    qsa('[data-rcb-subtotal]').forEach(function (el) { el.textContent = money(cart.total_price); });
  }

  function refreshCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart).catch(function () {});
  }

  function changeLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart).catch(function () { window.location.href = '/cart'; });
  }

  /* Detect a third-party cart drawer app (it auto-opens on /cart/add). If present, defer to it after ATC. */
  function appDrawerPresent() {
    return !!(qs('[class*="upcart"], [id*="upcart"], [class*="slidecart"], [id*="slide-cart"], [class*="rebuy-cart"], [class*="appstle-cart"], cart-drawer:not(.rcb-drawer), [id*="CartDrawer"], [class*="monster"], [id*="wecart"], [class*="sticky-cart"], [id*="corner-cart"]'));
  }

  function addToCart(btn) {
    if (!CFG) return false;
    var c = CFG[mode] || CFG.once || CFG.sub;
    if (!c) return false;
    var item = { id: CFG.variantId, quantity: 1 };
    if (c.planId) item.selling_plan = c.planId;
    var labelEl = btn ? qs('[data-rcb-atc-label]', btn) : null;
    var old = labelEl ? labelEl.textContent : null;
    if (labelEl) { labelEl.textContent = 'ADDING…'; }
    if (btn) { btn.disabled = true; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      if (!r.ok) throw new Error('atc');
      return refreshCart();
    }).then(function () {
      if (labelEl && old) { labelEl.textContent = old; }
      if (btn) { btn.disabled = false; }
      /* Let the store's cart app drawer take over if it exists; otherwise open ours */
      setTimeout(function () { if (!appDrawerPresent()) openDrawer(); }, 350);
    }).catch(function () {
      if (labelEl && old) { labelEl.textContent = old; }
      if (btn) { btn.disabled = false; }
      window.location.href = '/cart';
    });
    return true;
  }

  qsa('[data-rcb-atc]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      if (btn.disabled) { e.preventDefault(); return; }
      if (CFG) { e.preventDefault(); addToCart(btn); }
    });
  });
  var productForm = qs('[data-rcb-product-form]');
  if (productForm && CFG) {
    productForm.addEventListener('submit', function (e) { e.preventDefault(); addToCart(qs('[data-rcb-atc]', productForm)); });
  }

  refreshCart();
})();
